import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

export default {
    async ObtenerRegistrosExp(vm) {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("aiclave", datos.aiclave);
        if (datos.aiclave != 5) {
            let response = await vm.axios.post(`${vm.domain.domainNameForApi}Expediente/MovimientosReporte`, formData);
            return response.data;
        } else {
            let response = await vm.axios.post(`${vm.domain.domainNameForApi}Expediente/MovimientosReporteRCM`, formData);
            return response.data;
        }
    },
    async ObtenerRegistrosExpSinCI(vm) {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("aiclave", datos.aiclave);
        if (datos.aiclave != 5) {
            let response = await vm.axios.post(`${vm.domain.domainNameForApi}Expediente/MovimientosSinCIReporte`, formData);
            return response.data;
        } else {
            let response = await vm.axios.post(`${vm.domain.domainNameForApi}Expediente/MovimientosSinCIReporteRCM`, formData);
            return response.data;
        }
    },

}